module.exports = __webpack_public_path__ + "static/media/remove.ff4a139a.svg";